// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1gZEh","header":"ReportDetails_header__1yatt","title":"ReportDetails_title__65zYX","left":"ReportDetails_left__20d_A"};